import { FILTER } from "@/constants";

const VALID_FILTERS_KEYS: string[] = [
  FILTER.SORTING,
  FILTER.CHANNEL_NAME,
  FILTER.CHANNEL_TYPE,
  FILTER.FREETEXT,
  FILTER.LANGUAGE,
  FILTER.SENTIMENT,
  FILTER.END_DATE,
  FILTER.START_DATE,
  FILTER.MIN_REACH,
  FILTER.MENTION_KIND,
  FILTER.INSIGHT_TYPES,
];

export const hasValidFilters = (filters: Record<string, unknown> = {}) => {
  return Object.entries(filters).some(
    ([key, value]) => VALID_FILTERS_KEYS.includes(key) && value !== undefined
  );
};
